/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CSSProperties} from "react";
import * as emotion from "emotion";
import {COLORS} from "@res/colors";

export const CARD_BORDER_RADIUS = '6px';

export const cardStyleSpacing = emotion.css`
	& + & {
		margin-top: 16px;
  }
`;

export const cardStyle = emotion.css(
	{
		backgroundColor: COLORS.white,
		boxShadow: '0 0 3px 1px #ececec',
		borderRadius: `${CARD_BORDER_RADIUS}`
	}
);


export class Card
	extends React.Component<{ className?: string, style?: CSSProperties, children: React.ReactNode }> {

	constructor(props: { className?: string, style?: CSSProperties, children: React.ReactNode }) {
		super(props);
	}

	render() {
		return <div className={`ll_v_s ${cardStyle} ${cardStyleSpacing} ${this.props.className ? `${this.props.className}` : ''}`} style={{...this.props.style}}>
			{this.props.children}
		</div>;
	}
}
